export default __webpack_public_path__ + "static/media/36I-120775_-43979_0.98e4a998.jpg";